<template>
  <div id="support">

    <main>
      <div class="outer-wrapper">
        <h2>Contrology<sup>®</sup> Wall Tower Support</h2>

        <support-nav />

        <link-list
          heading="Assembly Instructions"
          :links="instructions"
        />

        <!-- <video-link
          heading="Maintenance Videos"
          :videos="videos"
        /> -->

        <!-- <section class="accordion-wrapper">
          <p class="heading">Common Questions</p>
          <accordion title="How should I properly store my springs?" animation="reveal">
            <p>The springs on the Contrology Arm Chair are the lightest spring in the suite. To keep them in working order and extend their wear, we suggest laying them over the top of the chair back when not in use.</p>
          </accordion>
        </section> -->

        <p>Didn't find your answer? Please use the Contact Us link in the footer.</p>
      </div>
    </main>
  </div>
</template>

<script>
  import SupportNav from '@/components/SupportNav.vue';
  import LinkList from '@/components/LinkList.vue';
  // import VideoLink from '@/components/VideoLink.vue';
  // import Accordion from '@/components/Accordion.vue';

  export default {
    name: 'supportwalltower',

    metaInfo: {
      title: "Wall Tower Assembly Instructions - Contrology",
      titleTemplate: "%s",
      meta: [
        {
          name: "description",
          content: "Get your Contrology Wall Tower Assembly Instructions here so you can get the full benefit of your Contrology Wall Tower."
        },
        {
          property: "og:image",
          content: "https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-support.jpg"
        }
      ]
    },

     components: {
      SupportNav,
      LinkList,
      // VideoLink,
      // Accordion
    },

    data() {
      return {
        instructions: [
          {
            title: 'The Contrology® Wall Tower Assembly Instructions (PDF)',
            url: 'https://s3.amazonaws.com/s3.pilates.com/resources/instructions/18932_2_Contrology_Wall_Tower_print_3-20-25_003.pdf'
          }
        ]
      }
    }
  }
  
</script>

<style scoped lang="scss">
.outer-wrapper {
  max-width: 680px;
  margin: 0 auto;
}

.heading {
  font-family: var(--roboto);
  font-size: 1rem;
  line-height: 1.3125;
  font-weight: 700;
  color: var(--black);
  margin-bottom: 30px;
}

.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.resp-container {
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;
}

.accordion {
  cursor: pointer;
  border: none;
  text-align: left;
  outline: none;
  transition: 0.4s;
  border-top: 2px solid #010101;
  padding: 5px 0;
  position: relative;
  z-index: -1;
}

.accordion p {
  font-family: var(--roboto);
  font-weight: 700;
  font-size: .8125em;
  line-height: 1.308;
  color:  #333;
  max-width: 80%;
}

.accordion:before {
  content: '\02795';
  font-size: 1em;
  color: #333;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.accordion.active:before {
  content: "\2796";
}

.accordion-wrapper:last-of-type {
  border-bottom:  2px solid #010101;
  margin-bottom: 35px;
}

.panel {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.2s ease-out;
}

.panel p, ol, table, .panel a {
  font-family: var(--roboto);
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.308;
  color:  var(--black);
  max-width: 90%;
}

.panel ol {
  padding-left: 16px;
  padding-bottom: 10px;
}

.panel li {
  margin-bottom: 10px;
}

table {
  border: 1px solid var(--black);
  max-width: 100%;
  width: 100%;
  border-collapse:separate; 
  border-spacing:0 5px;
  margin-bottom: 20px;
}

thead tr th{
  border-bottom: 1px solid var(--black);
  padding: 5px;
}

td {
  width: 33%;
  padding: 5px;
}

.center {
  text-align: center;
}

@media only screen and (min-width: 1024px) {
  h2 {
    margin-bottom: 10px;
  }
}
</style>
